module.exports = __webpack_public_path__ + "static/media/53-heli.b15992ff.jpg";